import { defineMessages } from "react-intl";

export default defineMessages({
  backtoptop: {
    id: "footer.backtotop"
  },
  cookies: {
    id: "footer.cookies"
  },
  disclaimer: {
    id: "footer.disclaimer"
  },
  legalnotice: {
    id: "footer.legalnotice"
  }
});



// WEBPACK FOOTER //
// ./src/components/UI/translations.js